/* MA-10 · the cost per participation, one wording and one definition wherever it shows (the builder's steps 2 and 3,
   a campaign's header, the roues): « X € par participation » with a tappable ⓘ, never a hover-only title.
   The number is `expectedCost` (every gift won is used); the roue editor's « Coût par participation » row adds the 35 % case. */
import { Hint } from '@/ui'
import { expectedCost, fmtEur, type Roue } from '@/lib/wheel'

export const COUT_DEFINITION = 'Coût moyen par participation, selon vos chances.'

export function CoutParParticipation({ roue, approx = false }: { roue: Roue; approx?: boolean }) {
  return (
    <span className="cout" data-testid="cout-participation">
      {approx ? '≈ ' : ''}{fmtEur(expectedCost(roue))} par participation{' '}
      <Hint label="Coût par participation">{COUT_DEFINITION}</Hint>
    </span>
  )
}
